import { render, staticRenderFns } from "./PolicyPasswordInput.vue?vue&type=template&id=4c9cb7d0"
import script from "./PolicyPasswordInput.vue?vue&type=script&lang=js"
export * from "./PolicyPasswordInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports